<div class="row mb-2" *ngIf="!global.docbool">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted pt-1">
                <div class="row col-12">
                    <div class="col-8">
                        <span>
                            <h4 *ngIf="DataFromList.newclient" class="mb-0 font-header">New Client</h4>
                            <h4 *ngIf="!DataFromList.newclient" class="mb-0 font-header">Update Client</h4>
                        </span>
                    </div>
                    <!--  -->


                    <div class="col-2">

                        <button class="btn  btn-sm text-end ms-1 " type="button"
                            *ngIf="ClientList.id=='00000000-0000-0000-0000-000000000000' "
                            [disabled]="isSaveorUpdateClientBoolean||
                            ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||
                               ClientList.email==undefined||ClientList.email==''||ClientList.email==null ||ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid"
                            tabindex="22" (click)="SaveorUpdateClient(ClientList,'no')">Save</button>

                        <button class="btn  btn-sm text-center ms-1 " type="button" *ngIf="isEditBoolean"
                            (click)="EditClientDetails()">Edit</button>


                        <button class="btn  btn-sm text-center ms-1 " type="button" *ngIf="isViewUpdate"
                            [disabled]="isSaveorUpdateClientBoolean|| ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||  
                             ClientList.email==undefined||ClientList.email==''||ClientList.email==null||ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid"
                            (click)="SaveorUpdateClient(ClientList,'no')" tabindex="22">Update
                        </button>


                        <button class="btn  btn-sm text-left ms-1 " type="button" (click)="BackToClientList()"
                            tabindex="22">Close</button>


                    </div>




                    <!--  -->



                    <div class="col-2 text-right">
                        <label class="notealert">Note: * fields are mandatory</label>
                    </div>
                </div>
            </div>
            <!--------------------------------------Card body starts here----------------->
            <div class="card-body pb-0 pt mb-4">
                <div class="row ">
                    <!-- <div class="col-lg-9">
                        <h5 class="mb-0 font-header ">Client Medical Record</h5>
                    </div> -->
                    <!-- <div class="col-lg-3 text-right mt-4">
                        <button type="button" *ngIf="ClientList.id=='00000000-0000-0000-0000-000000000000' "
                            [disabled]="ClientList.languageLid==undefined||ClientList.languageLid==''||ClientList.languageLid==null|| 
                            ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''" class="btn btn-sm" tabindex="22"
                            (click)="SaveorUpdateClient(ClientList)">Save</button>
                        <button type="button" *ngIf="isEditBoolean" class="btn btn-sm ms-1"
                            (click)="EditClientDetails()">Edit</button>
                        <button type="button" *ngIf="isViewUpdate" class="btn  btn-sm ms-1"
                           [disabled]="ClientList.dOB==undefined || ClientList.dOB==null || ClientList.dOB==''||ClientList.languageLid==undefined||ClientList.languageLid==''||ClientList.languageLid==null"
                            (click)="SaveorUpdateClient(ClientList)" tabindex="22">Update
                        </button>
                        <button type="button" class="btn btn-sm ms-1" (click)="BackToClientList()"
                            tabindex="22">Close</button>
                        
                    </div> -->
                    <!-- .............................................................................................................. -->



                    <div class="row">
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class="label-bold ">Status</label>&nbsp;
                                </div>
                                <div class="col-lg-8">
                                    <ng-select class="w-100" [(ngModel)]="ClientList.statusLid" [searchable]="true"
                                        [clearable]="true" [items]="statusList" bindLabel="lovName"
                                        [disabled]="global.viewTabs" bindValue="id">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- ............................................................. -->




                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class=" me-2 label-bold">Client</label>&nbsp;
                                </div>
                                <div class="col-lg-5 pt-2 ms-2">
                                    <label data-toggle="modal" data-target="#showPopup" placement="right">
                                        {{ClientList.lastName}}&nbsp;{{ClientList.firstName}}&nbsp;{{ClientList.middleName}}</label>
                                </div>
                            </div>
                        </div>

                        <!-- ........................................................................................ -->

                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-4 me-2 ">
                                    <label class=" label-bold ">DOB</label> &nbsp;
                                </div>
                                <div class="col-lg-4 me-1 pt-2">
                                    <label class=" me-1">{{ClientList.dOB}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class=" me-1 label-bold">Age</label> &nbsp;
                                </div>
                                <div class="col-lg-2 pt-2">
                                    <label>{{ClientList.age}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                     <div class="col-lg-4">
                                         <label class="me-1 label-bold">Support Planners</label>
                                    </div>
                                   <div class="col-lg-8">
                                        <!-- <div class="row" *ngFor="let sp  of SupporPlanerList"> -->
                                            <label *ngFor="let sp  of SupporPlanerList">{{sp.Value}}</label>
                                        <!-- </div> -->
                                    </div>
                            </div>
                        </div>
                    </div>
                    <!-- .....................................................2row............................................................... -->

                    <div class="row">
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class="label-bold ">Location</label>&nbsp;
                                </div>
                                <div class="col-lg-8">
                                    <ng-select class="w-100 col-lg-5" [(ngModel)]="ClientList.locationId"
                                        [searchable]="true" [clearable]="true" [items]="getLocationList"
                                        bindLabel="Value" [disabled]="global.viewTabs" bindValue="Key">
                                    </ng-select>
                                </div>

                            </div>

                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class="label-bold ">Mail</label> &nbsp;
                                </div>
                                <div class="col-lg-8 pt-2">
                                    <label>{{ClientList.email}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">

                            <div class="row">
                                <div class="col-lg-4 me-1 pt-1" style="margin-right:33px;">
                                    <label class=" label-bold ">Medicaid#</label>&nbsp;
                                </div>
                                <div class="col-lg-4  pt-2">
                                    <label>{{ClientList.medicaid}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">

                            <div class="row">
                                <div class="col-lg-4 me-1 pt-1" style="margin-right:33px;">
                                    <label class=" label-bold ">User Name</label>&nbsp;
                                </div>
                                <div class="col-lg-4  pt-2">
                                    <label>{{ClientList.userName}}</label>
                                </div>
                            </div>
                        </div>


                    </div>


                    <!-- ........................................................3 row.............................................................. -->


                    <div class="row">


                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-2 pt-1" style="margin-right:33px;">
                                    <label class=" label-bold ">Medicare#</label>&nbsp;
                                </div>
                                <div class="col-lg-8 pt-2">
                                    <label>{{ClientList.medicare}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-5 me-2">
                                    <label class="label-bold">Other Insurance#</label>&nbsp;
                                </div>
                                <div class="col-lg-6 pt-2">
                                    <label class="me-1">{{ClientList.insuranceNo}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-3">
                                    <label class="label-bold ">Program Type</label>
                                </div>
                                <div class="col-lg-8">
                                    <ng-select class="w-100 col-lg-5" [(ngModel)]="ClientList.typeofWaiverLid"
                                        [searchable]="true" [clearable]="true" [items]="TypeofWaiver"
                                        bindLabel="lovName" disabled="true" bindValue="id">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                         <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                            <div class="row">
                                <div class="col-lg-5 me-2">
                                    <label class="label-bold">CFSS Agency</label>&nbsp;
                                </div>
                                <div class="col-lg-6 pt-2">
                                    <label class="me-1">{{ClientList.cfssagencyname}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="row mt-1">
                <div class="col-lg-12 col-md-12">
                  <button type="button" [style.backgroundColor]="ClientList.isMAEligible?'green':'red'" 
                    style="color: white;" class="btn btn-sm mb-1" >Eligible</button>   
                     <button type="button" 
                    [style.backgroundColor]="(ClientList.waiver != null &&ClientList.waiver != '' )?'green':'red'"
                    style="color: white;" class="btn btn-sm mb-1 ms-2" [disabled]="isFieldEnabled">Waiver</button>
                  <button type="button" 
                    [style.backgroundColor]="(this.ClientList.spendDown==true)?'green':'red'"
                    style="color: white;" class="btn btn-sm mb-1 ms-2" [disabled]="isFieldEnabled">SpendDown</button>            
                  
                  
                </div>
              </div>


                    <!-- .................................................................................................................. -->

                </div>
            </div>


        </div>


        <!-- </div> -->
    </div>
</div>

<!-- ---------------Client Medical Record --------------------------->
<!-- <div class="row mb-2" *ngIf="!global.docbool">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="row">
                <div class="col-lg-4 divider1">
                    <div class="row mt-2 ms-1  me-1">
                        <div class="col">
                            <div class="row">
                                <div class="col-lg-2 col-md-2">
                                </div>
                                <!-- <div class="col-lg-4 col-md-4" [formGroup]="ClientDataForm">
                                    <select [(ngModel)]="ClientList.statusLid" formControlName="statusLid"
                                        class="form-control">
                                        <option [value]=st.id *ngFor="let st of statusList">{{st.lovName}}</option>
                                    </select>
                                </div> -->
<!-- <div class="col-lg-4 col-md-4" [formGroup]="ClientDataForm">
                                    <select [(ngModel)]="ClientList.locationId" formControlName="locationId"
                                        class="form-control">
                                        <option [value]=loc.Key *ngFor="let loc of getLocationList">{{loc.Value}}
                                        </option>
                                    </select>
                                </div> -->
<!-- <div class="col-lg-2 col-md-2">
                                </div>
                            </div>
                            <div class="row">
                                <div class=" ms-2col-lg-7 col-md-5">
                                    <label data-toggle="modal" data-target="#showPopup" placement="right"
                                        style="width: 178px;"
                                        class=" me-1 label-bold ">{{ClientList.lastName}}&nbsp;{{ClientList.firstName}}&nbsp;{{ClientList.middleName}}</label>
                                </div>
                            </div> -->
<!-- </form> -->
<!-- <div class="row">
                                <div class="col-lg-8 col-md-8">
                                    <label class=" me-1 label-bold ">DOB</label> &nbsp; <label
                                        class=" me-1 label-bold">{{ClientList.dOB}}</label>
                                </div>
                            </div> -->
<!-- <div class="row mb-1">
                                <div class="col-lg-3 col-md-3">
                                    <label class=" me-1 label-bold ">Eligibility</label>
                                </div>
                                <div class="col-lg-3 col-md-3">
                                    <button type="button"
                                        [style.backgroundColor]="ClientList.isMAEligible?'green':'red'"
                                        style="color: white;" class="btn  btn-sm "
                                        [disabled]="global.viewTabs">Eligible</button>

                                </div>
                                <div class="col-lg-2 col-md-2">
                                    <button type="button"
                                        [style.backgroundColor]="(ClientList.waiver != null &&ClientList.waiver != '' )?'green':'red'"
                                        style="color: white;" class="btn  btn-sm "
                                        [disabled]="global.viewTabs">Waiver</button>
                                </div>
                                <div class="col-lg-2 col-md-2">
                                    <label>{{ClientList.waiver}}</label>
                                </div>

                            </div> -->

<!-- <div class="row">
                                <div class="col-lg-5 col-md-3">
                                    <label class=" me-1 label-bold ">Medicaid#</label>
                                </div>
                                <div class="col-lg-5 col-md-2">
                                    <label class=" me-1 label-bold ">{{ClientList.medicaid}}</label>
                                </div>
                            </div> -->

<!-- <div class="row">
                                <div class="col-lg-5 col-md-5">
                                    <label class=" me-1 label-bold ">Other Insurance#</label>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <label class=" me-1 label-bold ">{{ClientList.insuranceNo}}</label>
                                </div>

                            </div> -->
<!-- 
                        </div>
                    </div>
                </div> -->
<!-- <div class="col-lg-2 divider">
                    <div>
                        <div class="row ms-1  me-1 mt-1 mb-1">
                            <div class="col-lg-12 col-md-12">
                                <div class="row" style="border-bottom:1px solid grey">
                                    <h6 class="headerInfo-label">Office Case Manager</h6>
                                </div>
                                <div class="row" *ngFor="let st of clientcasemanagerandContactDetail?.caseManagers">
                                    <div class="col-lg-12">
                                        <label class="font-header " data-toggle="modal"
                                            data-target="#showOfficeCaseManagerDetails"
                                            (click)="OfficeCaseManagerdetails(st)">{{st.name}}</label>
                                    </div>
                                    <div class="col-lg-12">
                                        <label class="font-header">{{st.phone}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
<!-- <div class="col-lg-2 divider">
                    <div>
                        <div class="row ms-1  me-1 mt-1 mb-1">
                            <div class="col-lg-12 col-md-12">
                                <div class="row" style="border-bottom:1px solid grey">
                                    <h6 class="headerInfo-label">Caregiver's</h6>
                                </div>
                                <div class="row" *ngFor="let st of clientcasemanagerandContactDetail?.caregivers">
                                    <div class="col-lg-12">
                                        <label class="font-header" data-toggle="modal"
                                            data-target="#showCaregiversDetails" (click)="Caregiversdetails(st)"
                                            [style.Color]="st.age > 18? '':'red' ">{{st.name}}
                                            <span>-</span>
                                            {{st.age}}</label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
<!-- <div class="col-lg-2 divider">
                    <div class="row ms-1  me-1 mt-1 mb-1">
                        <div class="col-lg-12 col-md-12">
                            <div class="row" style="border-bottom:1px solid grey">
                                <h6 class="headerInfo-label">Emergency Contact</h6>
                            </div>
                            <div class="row" *ngFor="let st of clientcasemanagerandContactDetail?.emergencyContacts">
                                <div class="col-lg-12">
                                    <label class="font-header" data-toggle="modal"
                                        data-target="#showEmergencyContactDetails"
                                        (click)="EmergencyContactdetails(st)">{{st.name}} ({{st.relationship}})</label>
                                </div>
                                <div class="col-lg-12">
                                    <label class="font-header">{{st.phoneNumber}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
<!-- <div class="col-lg-2 ">
                    <div class="row ms-1  me-1 mt-1 mb-1">
                        <div class="col-lg-12 col-md-12">
                            <div class="row col-12" style="border-bottom:1px solid grey">
                                <h6 class="headerInfo-label mt-1">Responsible Party</h6>
                            </div>
                            <div class="row"
                                *ngFor="let st of clientcasemanagerandContactDetail?.responsiblePartyContacts">
                                <div class="col-lg-12">
                                    <label class="font-header" data-toggle="modal"
                                        data-target="#showResponsiblePartyDetails"
                                        (click)="Responsiblepartydetails(st)">{{st.name}}({{st.relationship}})</label>
                                </div>
                                <div class="col-lg-12">
                                    <label class="font-header">{{st.phoneNumber}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
<!-- </div>
        </div>
    </div>
</div>   -->
<!-------------------------------  CLIENT TAB -------------------------------------------------->
<div class="row mb-2">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow" style="min-height: 500px;">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <nav *ngIf="!global.docbool">
                        <div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist">
                            <a class="nav-item nav-link " id="nav-notes-tab" data-bs-toggle="tab" href="#nav-notes"
                                role="tab"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'}"
                                aria-controls="nav-notes" aria-selected="true"
                                (click)="getTabActiveData('nav-notes'); isEnabledNotes=true">Notes</a>

                            <a class="nav-item nav-link active" id="nav-general-tab" data-bs-toggle="tab"
                                href="#nav-general" role="tab"
                                [ngClass]="{'disabled':ClientList.id===''  , 'mytab-inactive':ActiveTab!='nav-general','active':ActiveTab=='nav-general' }"
                                aria-controls="nav-general" aria-selected="true"
                                (click)="getTabActiveData('nav-general')">General</a>



                            <a class="nav-item nav-link " id="nav-contacts-tab" data-bs-toggle="tab"
                                href="#nav-contacts" role="tab"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-contacts','active':ActiveTab=='nav-contacts'}"
                                aria-controls="nav-contacts" aria-selected="false"
                                (click)="getTabActiveData('nav-contacts');isEnabledcontact=true">Contacts</a>

                            <a class="nav-item nav-link " id="nav-relationship-tab" data-bs-toggle="tab"
                                href="#nav-relationship"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-relationship','active':ActiveTab=='nav-relationship' }"
                                role="tab" aria-controls="nav-relationship" aria-selected="false"
                                (click)="getTabActiveData('nav-relationship'); isEnabledRelationship=true">Relationship</a>

                            <a class="nav-item nav-link " id="nav-relationshiptaxpercent-tab" data-bs-toggle="tab"
                                href="#nav-relationshiptaxpercent"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-relationshiptaxpercent','active':ActiveTab=='nav-relationshiptaxpercent' }"
                                role="tab" aria-controls="nav-relationshiptaxpercent" aria-selected="false"
                                (click)="getTabActiveData('nav-relationshiptaxpercent')">RelationshipTaxPercent</a>



                            <a class="nav-item nav-link " id="nav-documents-tab" data-bs-toggle="tab"
                                href="#nav-documents"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-documents','active':ActiveTab=='nav-documents' }"
                                role="tab" aria-controls="nav-documents" aria-selected="false"
                                (click)="getTabActiveData('nav-documents');reDirect()">Documents</a>

                            <a class="nav-item nav-link " id="nav-budget-tab" data-bs-toggle="tab" href="#nav-budget"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-budget','active':ActiveTab=='nav-budget' }"
                                role="tab" aria-controls="nav-budget" aria-selected="false"
                                (click)="getTabActiveData('nav-budget')">Budget
                            </a>

                            <a class="nav-item nav-link " id="nav-authorization-tab" data-bs-toggle="tab"
                                href="#nav-authorization"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'  , 'mytab-inactive':ActiveTab!='nav-authorization','active':ActiveTab=='nav-authorization' }"
                                role="tab" aria-controls="nav-authorization" aria-selected="false"
                                (click)="getTabActiveData('nav-authorization')">Authorization</a>
                            <a class="nav-item nav-link " id="nav-purchase-tab" data-bs-toggle="tab"
                                href="#nav-purchase"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-purchase','active':ActiveTab=='nav-purchase' }"
                                role="tab" aria-controls="nav-purchase" aria-selected="false"
                                (click)="getTabActiveData('nav-purchase')">Purchase
                            </a>
                            <a class="nav-item nav-link " id="nav-DynamicClientForm-tab" data-bs-toggle="tab"
                                href="#nav-DynamicClientForm"
                                [ngClass]="{'disabled':ClientList.id==='00000000-0000-0000-0000-000000000000'   , 'mytab-inactive':ActiveTab!='nav-DynamicClientForm','active':ActiveTab=='nav-DynamicClientForm' }"
                                role="tab" aria-controls="nav-DynamicClientForm" aria-selected="false"
                                (click)="getTabActiveData('nav-DynamicClientForm');isdynamicFormcontact=true;reDirect()">Dynamic
                                Onboarding Client Form</a>
                            <a class="nav-item nav-link" id="nav-DocumentClient-tab" data-bs-toggle="tab"
                                href="#nav-DocumentTab"
                                [ngClass]="{'disabled': ClientList.id == '00000000-0000-0000-0000-000000000000', 'mytab-inactive':ActiveTab!='nav-DocumentTab', 'active': ActiveTab=='nav-DocumentTab'}"
                                role="tab" aria-controls="nav-DocumentTab" aria-selected="false"
                                (click)="getTabActiveData('nav-DocumentTab'); isClientDocument=true;reDirect()">
                                Client Documents
                            </a>
                        </div>
                    </nav>


                    <div class="tab-content" id="nav-tabContent">
                        <!--------------------------- General----------- ------------------->
                        <div *ngIf="ActiveTab=='nav-general'">
                            <div class="tab-pane fade  " id="nav-general" role="tabpanel" aria-labelledby="nav-general"
                                [ngClass]="{'active':ActiveTab=='nav-general','show':ActiveTab=='nav-general'}">
                                <div class="row mb-2">
                                    <div class="col ps-0">

                                        <!-- ------------General Info-------------------- -->
                                        <div class="card-header transparent text-muted ms-2  me-3">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <h5 class="mb-0 font-header">General Info</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card-body widget-body pt-2 ms-2  me-3">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="row" [formGroup]="ClientDataForm">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class=" me-1 label-bold w-75">First Name<sup
                                                                    class="super-script">*</sup></label>
                                                            <input type="text" class="form-control w-100"
                                                                name="firstName" [(ngModel)]="ClientList.firstName"
                                                                formControlName="firstName" id="fname" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class=" me-1 label-bold  w-75">Middle Name</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="middleName" formControlName="middleName"
                                                                [(ngModel)]="ClientList.middleName">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1" [formGroup]="ClientDataForm">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Last Name<sup
                                                                    class="super-script">*</sup></label>
                                                            <input type="text" class="form-control w-100"
                                                                name="lastName" [(ngModel)]="ClientList.lastName"
                                                                formControlName="lastName">
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">DOB<sup
                                                                    class="super-script">*</sup></label>
                                                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                                name="dOB" id="dob" [selDate]="ClientList.dOB"
                                                                [options]="myDatePickerOptionsDOB"
                                                                (inputFieldChanged)="DOBdatechange($event)"
                                                                (dateChanged)="onDateChanged($event)"></my-date-picker>

                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex"
                                                            [formGroup]="ClientDataForm">
                                                            <label class=" me-1 label-bold  w-75">Gender<sup
                                                                    class="super-script">*</sup></label>

                                                            <ng-select class="w-100" [(ngModel)]="ClientList.genderLid"
                                                                formControlName="genderLid" [searchable]="true"
                                                                [clearable]="true" [items]="genderList"
                                                                bindLabel="lovName" name="genderLid" bindValue="id">
                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold"
                                                                style="width:67%;">Age</label>
                                                            <input type="text" class="form-control w-75 me-3" name="age"
                                                                [(ngModel)]="ClientList.age" disabled>
                                                            <button type="button" class="btn btn-sm border-0"
                                                                data-bs-toggle="modal" style="width:5rem"
                                                                [disabled]="global.viewTabs"
                                                                data-bs-target="#ClientSSNModel"
                                                                [style.backgroundColor]="(ClientList.ssn && !ssnerr) ? 'green' : 'red'">SSN</button>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">AKA</label>
                                                            <input type="text" class="form-control w-100" name="aKA"
                                                                [(ngModel)]="ClientList.aka"
                                                                [disabled]="global.viewTabs">
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Weight</label>
                                                            <input type="text" class="form-control w-100" name="weight"
                                                                [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.weight">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Medicaid#</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="medicaid" [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.medicaid" maxlength="20"
                                                                (keypress)="keyPress($event)">
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Medicare#</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="medicare" [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.medicare" maxlength="20"
                                                                (keypress)="keyPress($event)">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">County of Fiscal
                                                                Responsibility</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="medicare" [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.county_fiscalResponsibility" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Client InsuranceID
                                                            </label>
                                                            <input type="text" class="form-control w-100"
                                                                name="ClientInsurance" [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.insuranceNo" maxlength="20"
                                                                (keypress)="keyPress($event)">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Program Type</label>
                                                            <ng-select class="w-100"
                                                                [(ngModel)]="ClientList.typeofWaiverLid"
                                                                [searchable]="true" [clearable]="true"
                                                                [items]="TypeofWaiver" bindLabel="lovName"
                                                                bindValue="id" [disabled]="global.viewTabs">
                                                            </ng-select>
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Does client have
                                                                EIN</label>
                                                            <div class=" w-75  d-flex">
                                                                <div *ngFor="let i of isEinList" class=" d-flex ">
                                                                    <input type="radio" [value]="i.id"
                                                                        style="margin-left: 22px;"
                                                                        [(ngModel)]="ClientList.isEinLid"
                                                                        [disabled]="global.viewTabs"
                                                                        (ngModelChange)="EinChangesFun(ClientList.isEinLid)" />
                                                                    <span class="pt-2">{{i.lovName}}</span>
                                                                </div>
                                                            </div>
                                                            <button class="btn blue-btn btn-sm"
                                                                [disabled]="global.viewTabs" data-bs-toggle="modal"
                                                                data-bs-target="#ViewSecurity">View</button>

                                                            <!-- <input type="text" class="form-control m-1" placeholder="EIN number" [(ngModel)]="ClientList.isEin"
                                                                 (keypress)="keyPress($event)" [disabled]="!disableEin" /> -->


                                                        </div>
                                                    </div>

                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Languages
                                                            </label>
                                                            <ng-select class="w-100" [multiple]="true"
                                                                [(ngModel)]="ClientList.languageLid" [searchable]="true"
                                                                [disabled]="global.viewTabs" [clearable]="true"
                                                                [items]="LanguageList" bindLabel="lovName"
                                                                bindValue="id">
                                                            </ng-select>
                                                        </div>
                                                        

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Tax Id
                                                            </label>
                                                            <input type="text" [disabled]="global.viewTabs"
                                                                class="form-control w-100" name="tax"
                                                                [(ngModel)]="ClientList.taxId" />

                                                        </div>
                                                    </div>
                                                    

                                                    <div class="row mt-1 ">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Pay Source</label>
                                                            <ng-select class="w-100"
                                                                [(ngModel)]="ClientList.payerId"
                                                                [searchable]="true" [clearable]="true"
                                                                [items]="PayerList" bindLabel="Value"
                                                                bindValue="Key" [disabled]="global.viewTabs">
                                                            </ng-select>
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">UnEmployment Number
                                                            </label>
                                                            <input type="text" class="form-control w-100"
                                                                [disabled]="global.viewTabs" name="unemp"
                                                                [(ngModel)]="ClientList.unemploymentNumber" />
                                                        </div>

                                                    </div>

                                                    <div class="row mt-1 ">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">CFSS Agency</label>
                                                            <ng-select class="w-100"
                                                                [(ngModel)]="ClientList.cFSSAgencyId"
                                                                [searchable]="true" [clearable]="true"
                                                                [items]="CFSSAgencyList" bindLabel="Value"
                                                                bindValue="Key" [disabled]="global.viewTabs">
                                                            </ng-select>
                                                        </div>
                                                         <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">SUTA RATE</label>
                                                            <input type="number" class="form-control w-100"
                                                                [disabled]="global.viewTabs" name="unemp"
                                                                [(ngModel)]="ClientList.cyma_suta_rate" />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <!------------------------- Contact Info ------------------->
                                        <div class="card-header transparent text-muted ms-2  me-3">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <h5 class="mb-0 font-header">Contact Info</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body widget-body pt-2 ms-2  me-3">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class="me-1 label-bold w-50">Street</label>
                                                            <button type="button " [disabled]="global.viewTabs" class="btn blue-btn btn-sm me-4 ms-2"
                                                            data-bs-target="#SearchAddress" data-bs-toggle="modal" (click)="AddressGoogleMap = true"> Address
                                                            </button>
                                                            <input type="text" class="form-control w-100" name="street"
                                                                [disabled]="global.viewTabs || !ClientList.isHomelessClient"
                                                                [(ngModel)]="ClientList.street">
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 d-inline-flex"
                                                            >
                                                            <label class="mr-1 label-bold col-lg-5" style="padding: 0px">Manual Address
                                                            </label>
                                                            <input type="checkbox" [(ngModel)]="ClientList.isHomelessClient"
                                                            [disabled]="isFieldEnabled"
                                                              [ngModelOptions]="{standalone: true}">   
                                                            <!-- [ngClass]="{'has-danger':Email.touched && Email.invalid}"/ -->
                                                        </div>
                                                    </div>

                                                    <div class="row mt-1">
                                                        <div class="col-lg-6">

                                                        </div>
                                                        <div class="col-lg-6" style="text-align: center;">
                                                            <span
                                                                *ngIf="ClientDataForm.controls['ClientEmail'].touched && ClientDataForm.controls['ClientEmail'].invalid">
                                                                <p class="err">*Enter Valid Mail</p>
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-1" [formGroup]="ClientDataForm">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Email<sup
                                                                class="super-script">*</sup></label>
                                                        <input type="text" class="form-control w-100" name="email"
                                                            email="true" formControlName="ClientEmail"
                                                            [(ngModel)]="ClientList.email" />
                                                           
                                                        </div>
                                                        <!-- <span class="error" *ngIf="Email.touched && Email.invalid">required </span> -->
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Phone 1</label>
                                                            <input type="text" class="form-control w-100" name="phone12"
                                                                maxlength="14" minlength="14"
                                                                formControlName="ClientPhone1"
                                                                [(ngModel)]="ClientList.phone1"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" />
                                                           
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Phone 2</label>
                                                            <input type="text" class="form-control w-100" name="phone22"
                                                                formControlName="ClientPhone2" maxlength="14"
                                                                minlength="14" [(ngModel)]="ClientList.phone2"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" />
                                                          
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">Apt</label>
                                                            <input type="text" class="form-control w-100" name="apt"
                                                                [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.apt" />
                                                           
                                                        </div>

                                                    </div>
                                                    <div class="row mt-1">

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">City</label>
                                                            <input type="text" id="city" class="form-control w-100"
                                                                name="city" [disabled]="global.viewTabs || !ClientList.isHomelessClient"
                                                                [(ngModel)]="ClientList.city" />
                                                           

                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">State</label>

                                                            <ng-select [items]="stateList" id="state" class="w-100 "
                                                                [searchable]="true" [disabled]="global.viewTabs"
                                                                [(ngModel)]="ClientList.state" [clearable]="true"
                                                                bindLabel="name" bindValue="abbreviation">
                                                            </ng-select>
                                                           
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">

                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">County</label>
                                                            <input type="text" class="form-control w-100" name="county"
                                                                [disabled]="global.viewTabs || !ClientList.isHomelessClient"
                                                                [(ngModel)]="ClientList.county">
                                                           

                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <!-- <div class="col-lg-3 col-md-6 d-inline-flex"> -->
                                                                <label class=" me-1 label-bold  w-75">ZIP Code</label>
                                                                <input type="text" class="form-control  me-1 w-100"
                                                                    name="zipCode" [disabled]="global.viewTabs  || !ClientList.isHomelessClient"
                                                                    [(ngModel)]="ClientList.zipCode"
                                                                    (keypress)="keyPress($event)" minlength="5"
                                                                    maxlength="10" />
                                                           
                                                            <!-- </div> -->
                                                        </div>
                                                    </div>
                                                    <div class="row mt-1">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-75">CYMA Client ID</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="PClientID" [disabled]="global.viewTabs"
                                                                (keypress)="numbersOnly($event)"
                                                                [(ngModel)]="ClientList.pClientId" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-75">Priority Status</label>
                                                            <ng-select class="w-100"
                                                                [(ngModel)]="ClientList.priorityStatusLid"
                                                                [searchable]="true" [disabled]="global.viewTabs"
                                                                [clearable]="true" [items]="PriorityStatus"
                                                                bindLabel="lovName" bindValue="id">
                                                            </ng-select>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- -------------------------------BILL TO && CREATE PORTAL ----------------------------------- -->
                                    <div class="row">
                                        <div class="col ms-2">
                                            <button type="button" [disabled]="isFieldEnabled" class="btn btn-sm  me-4"
                                                (click)="billto= !billto;getStatesField()"> Bill To
                                            </button>

                                            <!-- <button class="btn btn-sm  me-4" (click)="ClearingNotes()"
                                                [disabled]="isFieldEnabled" data-bs-target="#CreatePortalModal"
                                                data-bs-toggle="modal">Create Client Account </button> -->
                                            <button type="button " [disabled]="isFieldEnabled"
                                                class="btn blue-btn btn-sm ml-2"
                                                (click)="clientEvv = !clientEvv;ClearingNotes();">Client
                                                EVV & Portal</button>

                                        </div>
                                    </div>
                                    <!--  -->
                                    <div class="row">
                                        <div class="col-lg-6" [hidden]="!billto">
                                            <div *ngIf="billto">
                                                <div class="card-header transparent text-muted">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <h5 class="mb-0 font-header ms-2">Bill To</h5>
                                                        </div>
                                                        <div class="col-lg-6">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--  -->
                                                <div class="card-body widget-body pt-2 ms-2 mt-1">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class=" me-1 label-bold w-50">BillTo Name</label>
                                                            <input type="text" class="form-control w-100"
                                                                name="billname" [(ngModel)]="ClientList.billto_Name" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class="label-bold  w-50">Street</label>
                                                            <input type="text" class="form-control w-100 " name="street"
                                                                [(ngModel)]="ClientList.billto_Street" />
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold  w-50">City</label>
                                                            <input type="text" class="form-control w-100" name="city"
                                                                [(ngModel)]="ClientList.billto_City" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">
                                                            <label class=" me-1 label-bold w-50">State</label>
                                                            <ng-select type="text" class=" w-100" [items]="stateList"
                                                                id="state" [searchable]="true" [clearable]="true"
                                                                bindLabel="name" bindValue="abbreviation"
                                                                [(ngModel)]="ClientList.billto_State">
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class=" me-1 label-bold  w-50">ZIP Code</label>
                                                            <input type="text" class="form-control w-100" name="zip"
                                                                (keypress)="keyPress($event)" minlength="5"
                                                                maxlength="10"
                                                                [(ngModel)]="ClientList.billto_Zipcode" />
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 d-inline-flex">

                                                            <label class=" me-1 label-bold w-50">Phone</label>
                                                            <input type="text" class="form-control w-100" name="phone"
                                                                maxlength="14" minlength="14"
                                                                [(ngModel)]="ClientList.billto_Phone"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" />
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                            <label class=" me-1 label-bold w-50">Email</label>
                                                            <input type="text" class="form-control w-100" name="email"
                                                                email="true" [(ngModel)]="ClientList.Email" />
                                                        </div>
                                                    </div>
                                                    <!--  -->
                                                </div>
                                                <!--  -->
                                            </div>
                                        </div>
                                        <div class="col-lg-12" [hidden]="!clientEvv">
                                            <div *ngIf="clientEvv">
                                                <div class="card-body widget-body pt-1">
                                                    <div class="row align-item-center pt-1">
                                                        <div style="display: contents;">
                                                            <h5 class="mb-0 font-header pt-2">Enable Client EVV & Portal
                                                            </h5>
                                                        </div>
                                                        <div class="col-lg-1 ">
                                                            <label class="toggle-control">
                                                                <input type="checkbox"
                                                                    [(ngModel)]="ClientList.requiredEVV"
                                                                    (change)="switchchange()"
                                                                    [disabled]="isFieldEnabled || checkClientStatus || global.clientId==0"
                                                                    [ngModelOptions]="{standalone: true}">
                                                                <span class="control"></span>
                                                            </label>
                                                        </div>
                                                        <div class="col-lg-4 col-md-6 d-inline-flex pt-1">
                                                            <label class="mr-1 label-bold w-150">User Name
                                                                <sup class="super-script"
                                                                    *ngIf="ClientList.requiredEVV">&nbsp;*</sup>
                                                            </label>
                                                            <input type="text" class="form-control w-50" name="userName"
                                                                [(ngModel)]="ClientList.userName"
                                                                [ngModelOptions]="{standalone: true}" disabled />
                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>



                        <!--................................... ........................relationtaxpercent............................................ -->


                        <div *ngIf="ActiveTab=='nav-notes'">
                            <div class="tab-pane fade" id="nav-notes" role="tabpanel" aria-labelledby="nav-notes"
                                [ngClass]="{'active':ActiveTab=='nav-notes','show':ActiveTab=='nav-notes'}">

                            </div>

                        </div>

                        <div *ngIf="ActiveTab=='nav-relationshiptaxpercent'">
                            <div class="tab-pane fade  " id="nav-relationshiptaxpercent" role="tabpanel"
                                aria-labelledby="nav-relationshiptaxpercent"
                                [ngClass]="{'active':ActiveTab=='nav-relationshiptaxpercent','show':ActiveTab=='nav-relationshiptaxpercent'}">
                                <div class="row mb-2">
                                    <div class="col ps-0">


                                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                                            <div class="row">
                                                <div class="col-lg-6">

                                                    <button type="button" class="btn blue-btn btn-sm text_left mr-2"
                                                        data-bs-toggle="modal" data-bs-target="#taxpercentModal"
                                                        (click)="Createupdate('new')"> Add RelationTax </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!--............ ....................................taxpercent grid.......................................................... -->

                                <div class="row mb-2"
                                    *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
                                       global.globalAgencyId!=''  && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
                                    <div class="col pl-0">
                                        <div widget class="card border-0 box-shadow">
                                            <div class="card-body  widget-body pt-2">
                                                <ejs-grid #grid id="grid" [dataSource]='data | async'
                                                    [allowResizing]='true' allowPaging='true' [allowSorting]='true'
                                                    [allowPaging]='true' [filterSettings]='filterOptions'
                                                    (dataStateChange)='dataStateChange($event)'
                                                    (actionBegin)="onActionComplete($event)" [allowFiltering]='true'
                                                    [showColumnChooser]="true">
                                                    <e-columns>
                                                        <e-column width=150 uid="action" headerText="Actions"
                                                            [showInColumnChooser]='false'>
                                                            <ng-template #template let-data>
                                                                <button class="btn btn-edit-table"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#taxpercentModal"
                                                                    (click)="Createupdate('edit');edit(data)"><i
                                                                        class="fa fa-edit"></i></button>&nbsp;

                                                                <button class="btn btn-delete-table"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#deleteTaxPercentmodal"
                                                                    (click)="setDeleteId(data.id)"><i
                                                                        class="fa fa-trash"></i></button>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=150 field="cliEmpName"
                                                            headerText="RelationShip" type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=150 field="employerEmployeeRelationshipName"
                                                            headerText="RelationShip Name" type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100
                                                            field="employerEmployeeRelationshipTaxName"
                                                            headerText="Tax Name" type='string'>
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column>
                                                        <e-column minWidth=100 field="percent" headerText="Percent"
                                                            type='number'>
                                                        </e-column>
                                                        <e-column minWidth=130 field="effectiveDate"
                                                            headerText="Effective Start Date" type="date"
                                                            [format]="formatOptions">
                                                        </e-column>
                                                         <e-column minWidth=130 field="effectiveEndDate"
                                                            headerText="Effective End Date" type="date"
                                                            [format]="formatOptions">
                                                        </e-column>

                                                    </e-columns>
                                                </ejs-grid>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- ..........................................relationtaxpercent modal.................................................... -->
                        <span id="opentaxpercentModal" data-bs-toggle="modal" data-bs-target="#taxpercentModal"></span>
                        <div class="modal fade modalbackgrod" id="taxpercentModal" data-bs-backdrop="false">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title font-header" *ngIf="ModelType =='new'">Create
                                            Relationship Taxpercent </h5>
                                        <h5 class="modal-title font-header" *ngIf="ModelType =='edit'">Update
                                            RelationShipTaxpercent
                                        </h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close">
                                            <span aria-hidden="true"></span>
                                        </button>
                                    </div>
                                    <div class="modal-body">



                                        <div class="row">
                                            <div class="col-lg-6">

                                                <label>RelationShip<sup class="super-script">*</sup>
                                                </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <ng-select class="w-100" #select (close)="select.blur()"
                                                    [(ngModel)]="RelationshipId"
                                                    (ngModelChange)="GetRelationshipdropdown(RelationshipId)"
                                                    [items]="clientemployeenamedropdown" bindLabel="Value"
                                                    bindValue="Key" [searchable]="true" [clearable]="true">

                                                </ng-select>
                                            </div>

                                        </div>


                                        <div class="row">
                                            <div class="col-lg-6">

                                                <label>RelationShip Name<sup class="super-script">*</sup>
                                                </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <ng-select class="w-100"
                                                    [(ngModel)]="employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId"
                                                    [items]="relationdropdown" bindLabel="Value" bindValue="Key"
                                                    [searchable]="true" [clearable]="true"
                                                    (ngModelChange)="GetRelationshipTaxdropdown(employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId)"
                                                    disabled>

                                                </ng-select>
                                            </div>

                                        </div>


                                        <div class="row">
                                            <div class="col-lg-6">

                                                <label>Tax<sup class="super-script">*</sup>
                                                </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <ng-select class="w-100"
                                                    [(ngModel)]="employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId"
                                                    [items]="relationtaxdropdown" bindLabel="Value" bindValue="Key"
                                                    [searchable]="true" [clearable]="true"
                                                    [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null">
                                                </ng-select>
                                            </div>

                                        </div>


                                        <div class="row">
                                            <div class="col-lg-6">
                                                <label>Percent<sup class="super-script">*</sup>
                                                </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="employeremployeerelationshipTaxPercentBO.percent"
                                                    [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null" />

                                            </div>
                                        </div>


                                        <div class="row">
                                            <div class="col-lg-6">
                                                <label>Effective Start Date<sup class="super-script">*</sup>
                                                </label>

                                            </div>
                                            <div class="col-lg-7">
                                                <my-date-picker [options]="myDatePickerOptions"
                                                    [selDate]="employeremployeerelationshipTaxPercentBO.effectiveDate"
                                                    placeholder="mm/dd/yyyy"
                                                    (inputFieldChanged)="DateFormat($event,'inputchanged','EffectiveDate')"
                                                    (dateChanged)="DateFormat($event,'datechanged','EffectiveDate')"
                                                    [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null">
                                                </my-date-picker>
                                            </div>
                                        </div>
                                         <div class="row">
                                            <div class="col-lg-6">
                                                <label>Effective End Date
                                                </label>

                                            </div>
                                            <div class="col-lg-7">
                                                <my-date-picker [options]="myDatePickerOptions"
                                                    [selDate]="employeremployeerelationshipTaxPercentBO.effectiveEndDate"
                                                    placeholder="mm/dd/yyyy"
                                                    (inputFieldChanged)="DateFormat($event,'inputchanged','effectiveEndDate')"
                                                    (dateChanged)="DateFormat($event,'datechanged','effectiveEndDate')"
                                                    [disabled]="RelationshipId==''||RelationshipId==undefined||RelationshipId==null">
                                                </my-date-picker>
                                            </div>
                                        </div> 


                                    </div>

                                    <div class="modal-footer">
                                        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='new'"
                                            (click)="SaveOrUpdateActivity('new')" [disabled]="(RelationshipId==''||RelationshipId==undefined||employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==''
            ||employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==''||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==undefined||
            employeremployeerelationshipTaxPercentBO.percent==0||
            employeremployeerelationshipTaxPercentBO.percent==undefined||
            employeremployeerelationshipTaxPercentBO.effectiveDate==''||employeremployeerelationshipTaxPercentBO.effectiveDate==undefined || isSaveorUpdateBoolean
             )"> Save & Close </button>

                                        <button class="btn blue-btn btn-sm" *ngIf="ModelType =='edit'"
                                            (click)="SaveOrUpdateActivity('edit')" [disabled]="(RelationshipId==''||RelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId==undefined||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==''||
            employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipTaxId==undefined||
            employeremployeerelationshipTaxPercentBO.percent==0||
            employeremployeerelationshipTaxPercentBO.percent==undefined||
            employeremployeerelationshipTaxPercentBO.effectiveDate==''||
            employeremployeerelationshipTaxPercentBO.effectiveDate==undefined || isSaveorUpdateBoolean
             )"> Update & Close </button>
                                        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>

                                    </div>

                                </div>
                            </div>
                        </div>



                        <span id="closeTaxPercentModal" data-bs-target="#deleteTaxPercentmodal"
                            data-bs-toggle="modal"></span>
                        <div class="modal fade" id="deleteTaxPercentmodal" data-bs-backdrop="false">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title font-header">Delete Record</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close">
                                            <span aria-hidden="true"></span>
                                        </button>

                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <label>Do you want to delete this record ?</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn blue-btn btn-sm"
                                            (click)="DeleteTaxPercent()">Yes</button>
                                        <button type="button" class="btn blue-btn btn-sm"
                                            data-bs-dismiss="modal">No</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!------------------------------------------ relationship Tap ------------------------------------------->
                    <div *ngIf="ActiveTab=='nav-relationship'">
                        <div class="tab-pane fade" id="nav-relationship" role="tabpanel"
                            aria-labelledby="nav-relationship"
                            [ngClass]="{'active':ActiveTab=='nav-relationship','show':ActiveTab=='nav-relationship'}">

                        </div>
                    </div>


                    <!------------------------------------ authorization Tap------------------------------------------------------>
                    <div *ngIf="ActiveTab=='nav-authorization'">
                        <div class="tab-pane fade" id="nav-authorization" role="tabpanel"
                            aria-labelledby="nav-authorization"
                            [ngClass]="{'active':ActiveTab=='nav-authorization','show':ActiveTab=='nav-authorization'}">
                            <div class="row mt-3 mr-0 ">
                                <div class="col-lg-12 ml-3 text-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- contacts -->
                    <div *ngIf="ActiveTab=='nav-contacts'">
                        <div class="tab-pane fade" id="nav-contacts" role="tabpanel" aria-labelledby="nav-contacts"
                            [ngClass]="{'active':ActiveTab=='nav-contacts','show':ActiveTab=='nav-contacts'}">
                            <div>
                                <div class="row mt-3 ms-2 mr-0 ">
                                    <div class="col-8 text-center">
                                        <input type="radio" [(ngModel)]="ClientEmployeeContact.Relationtype" value="Contacts" (ngModelChange)="ChangeContacType()">Contacts
                                        <input type="radio" [(ngModel)]="ClientEmployeeContact.Relationtype" value="SupportPlanner" (ngModelChange)="ChangeContacType()">Support Planner
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- -----------------------------------------------DOCUMENT TAP-------------------------------------------------- -->
                    <div *ngIf="ActiveTab=='nav-documents'">
                        <div class="tab-pane fade" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents"
                            [ngClass]="{'active':ActiveTab=='nav-documents','show':ActiveTab=='nav-documents'}">

                            <div class="row">
                                <div class="col">
                                    <div class="card-body widget-body pt-2 ms-2 me-3">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <app-client-onboardinglist [parentToOnboard]="parentToOnboard"
                                                    (dataEmitTemplate)="dataEmitFromOnboard($event)"
                                                    *ngIf="parentToOnboard.docToOnboarding">
                                                </app-client-onboardinglist>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- -----------------------------------------------BUDGET TAP---------------------------------------------- -->
                    <div *ngIf="ActiveTab=='nav-budget'">
                        <div class="tab-pane fade" id="nav-budget" role="tabpanel" aria-labelledby="nav-budget"
                            [ngClass]="{'active':ActiveTab=='nav-budget','show':ActiveTab=='nav-budget'}">

                            <div class="row">
                                <div class="col">
                                    <div class="card-body widget-body pt-2 ms-2 me-3">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <app-budgetimport [bugetInput]="BudgetImportData"
                                                    (dataemitBudgetimport)="dataemitBudgetimport($event)">
                                                </app-budgetimport>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-------------------------------------------PURCHASSE TAP------------------------------------------------------  -->
                    <div *ngIf="ActiveTab=='nav-purchase'">
                        <div class="tab-pane fade" id="nav-purchase" role="tabpanel" aria-labelledby="nav-purchase"
                            [ngClass]="{'active':ActiveTab=='nav-purchase','show':ActiveTab=='nav-purchase'}">
                        </div>
                    </div>

                    <!-------------------------------------------Onboarding Dynamic Client Form---------------------->
                    <div class="tab-pane fade" id="nav-DynamicClientForm" role="tabpanel"
                        aria-labelledby="nav-DynamicClientForm"
                        [ngClass]="{'active':ActiveTab=='nav-DynamicClientForm','show':ActiveTab=='nav-DynamicClientForm'}">
                        <div class="card-body  widget-body pb-0 pt-2 mb-4">
                            <div class="row">
                                <div class="col-lg-12">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <!----------------------------------------------------Client Document Tab---------------------------------->
            <div *ngIf="ActiveTab=='nav-DocumentTab'">
                <div class="tab-pane fade" id="nav-DocumentTab" role="tabpanel"
                    aria-labelledby="av-DocumentTab"
                    [ngClass]="{'active':ActiveTab=='nav-DocumentTab','show':ActiveTab=='nav-DocumentTab'}">
                    <div class="card-body  widget-body pb-0 pt-2 mb-4">
                        <div class="row">
                            <div class="col-lg-12">
                                <app-client-document></app-client-document>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <app-client-employee-relationship [CERelation]="ClientEmployeeRelationship" *ngIf="isRelationShip">
                </app-client-employee-relationship>

                <app-client-employee-contact [ContactRelation]="ClientEmployeeContact" *ngIf="isRelationcontact">
                </app-client-employee-contact>
                <app-client-support-relation [ContactRelation]="ClientEmployeeContact" *ngIf="ClientEmployeeContact.Relationtype == 'SupportPlanner'">
                </app-client-support-relation>
                <app-client-employee-dynamicform [DynamicFormRelation]="ClientEmployeeDynamicForm"
                    *ngIf="isdynamicFormcontact">
                </app-client-employee-dynamicform>

                <app-client-authorization [ClientAuth]="ClientAuthList" *ngIf="isAuthView">
                </app-client-authorization>
                <app-purchase-request *ngIf="purchaseemit" [purchaseEmit]="purchaseEmitBo"></app-purchase-request>

                <app-client-notes *ngIf="isNotes" [Client]="ClientList">
                </app-client-notes>

            </div>
        </div>
    </div>
</div>
<span>
    <app-budgetplan-form *ngIf="BudgetImportData.edit" (dataEmitFromCDCSPlan)="dataEmitFromCDCSPlan($event)"
        [budgetPlan]="BudgetImportData">
    </app-budgetplan-form>
</span>

<!-- ---------------------------------------------------SSN NUMBER--------------------------------------------------------------------------- -->
<span id="closeClientssnModal" data-bs-target="#ClientSSNModel" data-bs-toggle="modal"></span>
<div class="modal fade " id="ClientSSNModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Social Security Number</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class=" modal-body">
                <div class="row">
                    <div class="col-lg-2">
                        <label class="label-bold">SSN&nbsp;:</label>
                    </div>
                    <div class="col-lg-10">
                        <input type=" text" [(ngModel)]="ClientList.ssn" class="form-control" minlength=9 maxlength=9
                            (ngModelChange)="ClientChangeSSN()" (keypress)="keyPress($event)">
                    </div>
                </div>
                <div class="col offset-2 mt-1">
                    <span class="col-8 offset-2 help-block text-danger " *ngIf="ssnerr">
                        <p>Enter Valid SSN Number</p>
                    </span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="ssnerr"
                    (click)="closeSsnValidation()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-----------------------care coordinator---------------------------------------------------------------------->
<span id="Careopen" data-bs-toggle="modal" data-bs-target="#carecoordinator"></span>
<div class="modal hide fade modalbackgrod" id="carecoordinator" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog  ICD-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Care Coordinator</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ICD-modalbody">

            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-sm btn-primary" (click)="careenable=false;"
                    data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>


<span id="PORTALMODAL" data-bs-toggle="modal" data-bs-target="#CreatePortalModal"></span>
<div class="modal fade" id="CreatePortalModal" data-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Email : <strong class="pl-1"> {{ClientList.email}}</strong></p>
                <label>Username</label><sup class="super-script">*</sup>
                <input type="text" class="form-control" [(ngModel)]="sendToPortalBO.username">
                <label class="mx-auto" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>
                <textarea class="form-control" [(ngModel)]="sendToPortalBO.agencyNote"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="CreatePoratl()"
                    [disabled]="sendToPortalBO.username==''||sendToPortalBO.username==null||sendToPortalBO.username==undefined">Submit</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>



<span id="openSecurityModal" data-bs-target="#ViewSecurity" data-bs-toggle="modal"></span>
<div class="modal fade" id="ViewSecurity" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    EIN
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <!-- <div class="row pb-2">
                    <div class="col-lg-4 col-md-4">
                        <label class=" me-1 label-bold  w-100">Tax Id</label>
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <input type="text" class="form-control w-75" name="tax" [(ngModel)]="ClientList.taxId"
                            [disabled]="global.viewTabs" />
                    </div>
                </div>
                <div class="row pb-2">
                    <div class="col-lg-4 col-md-4">
                        <label class=" me-1 label-bold  w-100">UnEmployment Number</label>
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <input type="text" class="form-control w-75" name="unemp"
                            [(ngModel)]="ClientList.unemploymentNumber" [disabled]="global.viewTabs" />
                    </div>
                </div> -->
                <div class="row" style="padding-left: 20px;padding-right: 20px;">
                    <!-- <div class="col-lg-4 col-md-4">
                        <label class="label-bold w-100">Does client have EIN</label>
                    </div>
                    <div class="col-lg-8 col-md-8 d-inline-flex">
                        <div *ngFor="let i of isEinList" class="d-flex">
                            <input type="radio" [value]="i.id" [(ngModel)]="ClientList.isEinLid"
                                [disabled]="global.viewTabs"
                                (ngModelChange)="EinChangesFun(ClientList.isEinLid)" />
                            <span class="pt-2">{{i.lovName}}</span> -->
                    <!-- </div> -->
                    <input type="text" class="form-control m-1" placeholder="EIN number" [(ngModel)]="ClientList.isEin"
                        (keypress)="keyPress($event)" [disabled]="!disableEin || global.viewTabs" />
                    <!-- </div> -->
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="openEvvModal" data-bs-target="#EnableEvv" data-bs-toggle="modal">
</span>
<div class="modal fade" id="EnableEvv" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header">
                    Disable EVV</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="ClientList.requiredEVV=!ClientList.requiredEVV"></button>
            </div>
            <div class="modal-body">
                <label *ngIf="!ClientList.requiredEVV "> This will log out all the sessions for this user!</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="passwordResetFunction()">Continue</button>
                <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal"
                    (click)="ClientList.requiredEVV=!ClientList.requiredEVV">No</button>
            </div>
        </div>
    </div>
</div>

<!-- AddressGoogleMap -->
<span id="openSearchAddressModal" data-bs-target="#SearchAddress" data-bs-toggle="modal">
</span>
<div class="modal fade" id="SearchAddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="font-header">
          Search Address</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="AddressGoogleMap=false;">&times;</button>
      </div>
      <div class="modal-body" style="min-height: 100px;">
        <div class="row">
          <div class="col-lg-12">
            <app-google-map *ngIf="AddressGoogleMap==true" (GoogleMapEmit)="EmitGoogleMapComponent($event)"></app-google-map>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm"  data-bs-dismiss="modal"
          (click)="AddressGoogleMap=false">Cancel</button>
      </div>
    </div>
  </div>
</div>


 <span id="closewarningTaxPercentModal" data-bs-target="#warningTaxPercet"
                            data-bs-toggle="modal"></span>
                        <div class="modal fade" id="warningTaxPercet" data-bs-backdrop="false">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title font-header">Warning</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="validationType='updateclient'"
                                            aria-label="Close">
                                            <span aria-hidden="true"></span>
                                        </button>

                                    </div>
                                    <div class="modal-body">
                                       
                                         <div class="row">
                    <div class="col-lg-12"   >
                        <p class="err" style="text-align:center;font-size:1.2rem;" >{{taxErr_msg}}
                            </p>
                  
                     </div>
                </div>
                                    </div>
                                     <div class="modal-footer d-flex justify-content-between" *ngIf="validationType== 'updateclient'" >
                <p><span><b> Do You Want To Continue? </b></span></p>
              <span>  <button class="btn  btn-sm me-2" data-bs-dismiss="modal" (click)="SaveorUpdateClient(ClientList,'yes')">
                <span> Yes
                </span> </button>
                <button type="button"  class="btn  btn-sm ms-2" data-bs-dismiss="modal" (click)="validationType='updateclient'"
                >No</button></span>
            </div>
                                </div>
                            </div>
                        </div>